import { render, staticRenderFns } from "./UserIcon.vue?vue&type=template&id=fd2c752a&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd2c752a')) {
      api.createRecord('fd2c752a', component.options)
    } else {
      api.rerender('fd2c752a', component.options)
    }
    module.hot.accept("./UserIcon.vue?vue&type=template&id=fd2c752a&functional=true&", function () {
      api.rerender('fd2c752a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/assets/icons/UserIcon.vue"
export default component.exports